import styles from "./Spinner.module.css";

interface SpinnerProps {
  size?: "small" | "medium";
  /** Text announced to assistive tech and shown beside the spinner. */
  label?: string;
  /** Inside a control that already announces its state (e.g. a busy Button). */
  decorative?: boolean;
}

export function Spinner({ size = "medium", label = "Loading…", decorative = false }: SpinnerProps) {
  const ring = <span className={`${styles.spinner} ${styles[size]}`} aria-hidden="true" />;
  if (decorative) return ring;
  return (
    <span className={styles.wrap} role="status">
      {ring}
      <span>{label}</span>
    </span>
  );
}
